import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import React from "react";
import { promoCodeChangeStatusApi } from "services/promocode";
import { toastMessage } from "utils/toastMessage";

const BlockPromoCode = ({
  show,
  close,
  promoCodeData,
  promoCodeList,
  setPromoCodeList = () => {},
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

  // ---------------change-status-API---------------
  const changeStatusHandler = async () => {
    try {
      const reqData = {
        id: promoCodeData?._id || "",
        status: promoCodeData.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      setButtonLoader(true);
      const res = await promoCodeChangeStatusApi(reqData);
      const { code, data, message } = res?.data;
      if (code === 200) {
        setPromoCodeList(
          promoCodeList.map((item) =>
            item._id === promoCodeData._id
              ? { ...item, status: reqData.status }
              : item,
          ),
        );
        close();
        toastMessage(message, "success", "changeUserStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  return (
    <PopupModal
      show={show}
      handleClose={close}
      content="Are you sure you want to hide this coupon from users?"
      title="Change Coupon Status"
      buttonLoader={buttonLoader}
      action={changeStatusHandler}
    />
  );
};

export default BlockPromoCode;
